module.exports = __webpack_public_path__ + "img/Proof.023d1157.svg";